import { be, bm } from '@skippay/core/utils/classUtils';
import { throttle } from 'lodash/fp';
import React, { Children, PropsWithChildren, useEffect, useRef } from 'react';
import { useEvent } from 'react-use';

import './index.sass';

const MODULE_NAME = 'HeaderOffset';

interface Props {
	onOffsetChange: (offset: number) => void | undefined;
}

function HeaderOffset(props: PropsWithChildren<Props>): JSX.Element {
	const { children, onOffsetChange } = props;
	const nonEmptyChildrenCount = Children.toArray(children).filter(Boolean).length;

	const headerWrapperRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		const handleResize = () =>
			headerWrapperRef.current && onOffsetChange(headerWrapperRef.current.clientHeight);

		handleResize();
		const throttledHandleResize = throttle(30, handleResize);
		window.addEventListener('resize', throttledHandleResize);
		return () => {
			throttledHandleResize.cancel();
			window.removeEventListener('resize', throttledHandleResize);
		};
	}, [nonEmptyChildrenCount, onOffsetChange]);

	useEvent('exponea-download-app', () => {
		if (headerWrapperRef.current) {
			onOffsetChange(headerWrapperRef.current.clientHeight)
		}
	})

	return (
		<div className={bm(MODULE_NAME)}>
			<div className={be(MODULE_NAME, 'fixed')}>
				<div ref={headerWrapperRef} className={be(MODULE_NAME, 'headerWrapper')}>
					{children}
				</div>
			</div>
		</div>
	);
}

export default HeaderOffset;
